<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <h4 class="panel-title">
              <span class="title">Gerenciamento dos Perfis de Acesso.</span>
              <br />
              <span class="navigation">Cadastros > Perfil de Acesso</span>
            </h4>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="nome">Perfil:</label>
              <span class="p-fluid">
                <InputText type="text" id="nome" v-model="nomePerfil" disabled="true" />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable :value="perfilList" :paginator="true" :rows="10" :autoLayout="true" >
              <Column field="idPagina.menu" header="Menu"></Column>
              <Column field="idPagina.pagina" header="Página"></Column>
              <Column field="habilitarBol" header="Habilitar">
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.habilitarBol" :binary="true" />
                </template>
              </Column>
              <Column field="salvarBol" header="Salvar">
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.salvarBol" :binary="true" />
                </template>
              </Column>
              <Column field="alterarBol" header="Alterar">
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.alterarBol" :binary="true" />
                </template>
              </Column>
              <Column field="excluirBol" header="Excluir">
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.excluirBol" :binary="true" />
                </template>
              </Column>
              <Column field="imprimirBol" header="Imprimir">
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.imprimirBol" :binary="true" />
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
          <template>
            <Button
              @click="salvar()"
              label="Gravar"
              title="Gravar"
              type="button"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check"
            />

            <router-link to="/perfilAcesso">
              <Button
                label="Voltar"
                title="Voltar"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-arrow-left"
              ></Button>
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PerfilAcessoService from "../services/nfse/perfil.acesso.service";

export default {
  name: "perfilAcessoCadastro",
  data() {
    return {
      display: false,
      displayCadPerfil: false,
      search: false,
      currentUser: null,
      filtro: "",
      perfilList: [],
      perfilId: null,
      nomePerfil: null
    };
  },
  created() {
    this.perfilId = this.$route.params.id;
    this.nomePerfil = this.$route.params.nome;
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    pesquisar() {
      this.search = true;
      PerfilAcessoService.findAllByPerfil(this.perfilId).then(
        perfil => {
          this.perfilList = perfil.data;
        },
        error => {
          let errorMessage = "Houve um problema listar Perfis de Acesso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    salvar() {
      PerfilAcessoService.save(this.perfilList).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Perfil Acesso salvo com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao salvar o Perfil de Acesso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    }
  }
};
</script>

<style scoped>
</style>